import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const ResetPassword = () => {
  const { userCode } = useParams();
  const navigate = useNavigate();
  const [correo, setCorreo] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [showModal, setShowModal] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const response = await fetch(
        'https://analitica.phantomx.com.ec/analitica/v1/portal_bi/seguridad/enviar_correo_cambio_contrasenia',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Application: 'UEhBTlRPTVhfREJJ',
            IdOrganizacion: '365509c8-9596-4506-a5b3-487782d5876e',
          },
          body: JSON.stringify({ correo }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setMessage('✅ Correo enviado correctamente. Revisa tu bandeja de entrada.');
        setShowModal(true);
        setTimeout(() => navigate('/login'), 3000);
      } else {
        setMessage(data.message || '❌ Error al enviar el correo.');
        setShowModal(true);
      }
    } catch (error) {
      console.error(error);
      setMessage('⚠️ Error de conexión con el servidor.');
      setShowModal(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reset-password-container" style={{ maxWidth: 400, margin: '50px auto' }}>
      <h2 className="text-center mb-4">Actualizar contraseña</h2>
      {userCode && (
        <p className="text-center">
          Código de usuario: <strong>{userCode}</strong>
        </p>
      )}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Correo electrónico</label>
          <input
            type="email"
            className="form-control"
            placeholder="Ingresa tu correo"
            value={correo}
            onChange={(e) => setCorreo(e.target.value)}
            required
          />
        </div>
        <div className="text-center">
          <button type="submit" className="btn btn-primary mt-3 px-4" disabled={loading}>
            {loading ? 'Enviando...' : 'Enviar correo'}
          </button>
        </div>
      </form>

      {/* Modal Bootstrap */}
      {showModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ background: 'rgba(0,0,0,0.5)' }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content text-center">
              <div className="modal-header">
                <h5 className="modal-title w-100">Notificación</h5>
                <button type="button" className="close" onClick={() => setShowModal(false)}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <p>{message}</p>
              </div>
              <div className="modal-footer justify-content-center">
                <button type="button" className="btn btn-secondary px-4" onClick={() => setShowModal(false)}>
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ResetPassword;
